/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, toRefs, h, createVNode, mergeProps } from 'vue';
import { i as isString_1 } from '../_chunks/dep-2684fd15.mjs';
import { i as isFunction_1 } from '../_chunks/dep-0b4185fe.mjs';
import { g as get_1 } from '../_chunks/dep-6d14fb16.mjs';
import { formatRowAttributes, formatRowClassNames } from './utils.mjs';
import { getColumnFixedStyles } from './hooks/useFixed.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import useRowspanAndColspan, { getCellKey } from './hooks/useRowspanAndColspan.mjs';
import useClassName from './hooks/useClassName.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-0c515b62.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-dcf624da.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../_chunks/dep-241fdd8c.mjs';
import '../_chunks/dep-050b3eb2.mjs';
import '../_common/js/log/index.mjs';
import '../_common/js/log/log.mjs';
import '../_common/js/utils/getScrollbarWidth.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-8c39d78a.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../utils/render-tnode.mjs';
import '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TFoot = defineComponent({
  name: "TFoot",
  props: {
    rowKey: String,
    isFixedHeader: Boolean,
    rowAndColFixedPosition: Map,
    footData: Array,
    columns: Array,
    rowAttributes: [Array, Object, Function],
    rowClassName: [Array, String, Object, Function],
    thWidthList: [Object],
    footerSummary: [String, Function],
    rowspanAndColspanInFooter: Function
  },
  setup: function setup(props, context) {
    var renderTNode = useTNodeJSX();
    var classnames = useClassName();

    var _toRefs = toRefs(props),
        footData = _toRefs.footData,
        columns = _toRefs.columns,
        rowKey = _toRefs.rowKey,
        rowspanAndColspanInFooter = _toRefs.rowspanAndColspanInFooter;

    var _useRowspanAndColspan = useRowspanAndColspan(footData, columns, rowKey, rowspanAndColspanInFooter),
        skipSpansMap = _useRowspanAndColspan.skipSpansMap;

    var renderTFootCell = function renderTFootCell(p) {
      var col = p.col,
          row = p.row;

      if (isFunction_1(col.foot)) {
        return col.foot(h, p);
      }

      if (isString_1(col.foot) && context.slots[col.foot]) {
        return context.slots[col.foot](p) || col.foot;
      }

      return col.foot || get_1(row, col.colKey);
    };

    return _objectSpread(_objectSpread({
      skipSpansMap: skipSpansMap
    }, classnames), {}, {
      renderTFootCell: renderTFootCell,
      renderTNode: renderTNode
    });
  },
  render: function render() {
    var _this$footData,
        _this = this;

    if (!this.columns) return null;
    var theadClasses = [this.tableFooterClasses.footer, _defineProperty({}, this.tableFooterClasses.fixed, this.isFixedHeader)];
    var footerDomList = (_this$footData = this.footData) === null || _this$footData === void 0 ? void 0 : _this$footData.map(function (row, rowIndex) {
      var trAttributes = formatRowAttributes(_this.rowAttributes, {
        row: row,
        rowIndex: rowIndex,
        type: "foot"
      });
      var customClasses = formatRowClassNames(_this.rowClassName, {
        row: row,
        rowIndex: rowIndex,
        type: "foot"
      }, _this.rowKey || "id");
      return createVNode("tr", mergeProps(trAttributes, {
        "key": rowIndex,
        "class": customClasses
      }), [_this.columns.map(function (col, colIndex) {
        var _this$thWidthList;

        var cellSpans = {};
        var spanState = null;

        if (_this.skipSpansMap.size) {
          var _spanState, _spanState2;

          var cellKey = getCellKey(row, _this.rowKey, col.colKey, colIndex);
          spanState = _this.skipSpansMap.get(cellKey) || {};
          ((_spanState = spanState) === null || _spanState === void 0 ? void 0 : _spanState.rowspan) > 1 && (cellSpans.rowspan = spanState.rowspan);
          ((_spanState2 = spanState) === null || _spanState2 === void 0 ? void 0 : _spanState2.colspan) > 1 && (cellSpans.colspan = spanState.colspan);
          if (spanState.skipped) return null;
        }

        var tdStyles = getColumnFixedStyles(col, colIndex, _this.rowAndColFixedPosition, _this.tableColFixedClasses);

        var style = _objectSpread({}, tdStyles.style);

        if ((_this$thWidthList = _this.thWidthList) !== null && _this$thWidthList !== void 0 && _this$thWidthList[col.colKey]) {
          style.width = "".concat(_this.thWidthList[col.colKey], "px");
        }

        return createVNode("td", mergeProps(_objectSpread({
          key: col.colKey
        }, cellSpans), {
          "class": tdStyles.classes,
          "style": style
        }), [_this.renderTFootCell({
          row: row,
          rowIndex: rowIndex,
          col: col,
          colIndex: colIndex
        })]);
      })]);
    });
    var footerSummary = this.renderTNode("footerSummary");
    if (!footerSummary && (!this.footData || !this.footData.length)) return null;
    return createVNode("tfoot", {
      "ref": "tFooterRef",
      "class": theadClasses
    }, [footerSummary && createVNode("tr", {
      "class": this.tableFullRowClasses.base
    }, [createVNode("td", {
      "colspan": this.columns.length
    }, [createVNode("div", {
      "class": this.tableFullRowClasses.innerFullElement
    }, [footerSummary])])]), footerDomList]);
  }
});

export { TFoot as default };
//# sourceMappingURL=tfoot.mjs.map
